<dx-app class="art-app">
  @if (userStore.isLoading()) {
    <dx-container class="loading">
      <dx-loading-indicator label="{{ 'app.loading-indicator' | transloco }}"></dx-loading-indicator>
    </dx-container>
  } @else if (userStore.user()) {
    <art-app-header slot="header"></art-app-header>
    <div class="body">
      <art-app-navigation></art-app-navigation>
      @if (isSettingsRoute()) {
        <art-settings-menu animate.enter="open-settings" animate.leave="close-settings"></art-settings-menu>
      }
      <div class="content">
        <router-outlet></router-outlet>
      </div>
    </div>
    <art-modal-switch-box></art-modal-switch-box>
  }
  @if (errorService.errorAlertContent()) {
    <dx-alert
      titlestring="{{ 'error.title' | transloco }}"
      content="{{ errorService.errorAlertContent() }}"
      type="error"
      icon="warndreieck"
      visible="true"
    >
      <dx-button
        type="text"
        slot="action"
        label="{{ errorService.errorAlertButton() | transloco }}"
        (click)="onCloseErrorAlert()"
      ></dx-button>
    </dx-alert>
  }
</dx-app>
